import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "bootstrap/dist/css/bootstrap.min.css";
import '@fortawesome/fontawesome-free/css/all.min.css'; 

import { ModuleRegistry } from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { ContextMenuModule, SetFilterModule } from 'ag-grid-enterprise';
import { AllCommunityModule } from 'ag-grid-community'; 

ModuleRegistry.registerModules([
  AllCommunityModule,
  ClientSideRowModelModule,
  ContextMenuModule,
  SetFilterModule
]);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
